import { useQuery } from '@tanstack/react-query'
import { getData } from '../../apis/api.helpers'
import apiUrl from '../../apis/api.url'
import { parseQueryParams } from '../../utilities/parsers'
import { useAuthStore } from '../../store/authStore'

const buildUrlWithParams = (baseUrl: string) => {
  return `${baseUrl}${parseQueryParams()}`
}

const fetchCareers = async () => {
  const url = buildUrlWithParams(apiUrl.CAREER_LIST)
  const response = await getData(url)
  return response
}
export const useCareersList = () => {
  return useQuery(['careers_listing'], () => fetchCareers(), {
    refetchOnWindowFocus: false,
  })
}
const fetchRti = async () => {
  const url = buildUrlWithParams(apiUrl.RTI)
  const response = await getData(url)
  return response
}
const fetchRtiUser = async () => {
  const url = buildUrlWithParams(apiUrl.RTI_USER)
  const response = await getData(url)
  return response
}

export const useRti = () => {
  const authenticated = useAuthStore((state) => state.authenticated)

  return useQuery(
    ['rti_listing', authenticated],
    () => {
      if (authenticated) {
        return fetchRtiUser()
      } else {
        return fetchRti()
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  )
}
const fetchActsRules = async () => {
  const url = buildUrlWithParams(apiUrl.ACTS_RULES)
  const response = await getData(url)
  return response
}
const fetchActsRulesUser = async () => {
  const url = buildUrlWithParams(apiUrl.ACTS_RULES_USER)
  const response = await getData(url)
  return response
}

export const useActsRules = () => {
  const authenticated = useAuthStore((state) => state.authenticated)

  return useQuery(
    ['acts_listing', authenticated],
    () => {
      if (authenticated) {
        return fetchActsRulesUser()
      } else {
        return fetchActsRules()
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  )
}

const fetchTenders = async () => {
  const url = buildUrlWithParams(apiUrl.TENDERS)
  const response = await getData(url)
  return response
}
export const useTenders = () => {
  return useQuery(['tenders_listing'], () => fetchTenders(), {
    refetchOnWindowFocus: false,
  })
}
